<template>
  <div class="new-message-panel">
    <!-- 标题栏 -->
    <div class="left_title">
      <div class="message-tabs">
        <div class="tab-item" :class="{ active: activeTab === 'new' }" @click="switchTab('new')">
          <span class="tab-name nowrap">新消息</span>
          <el-badge v-if="newMessageTotal > 0" :value="newMessageTotal" :max="99" class="tab-badge"></el-badge>
          <img class="tab-sound-icon w-20 h-20 pointer" :src="$store.state.sound.newMessageMuted
            ? require('@/assets/mute.png')
            : require('@/assets/unmute.png')
            " alt="" @click.stop="toggleNewMessageSound" />
        </div>
        <div class="tab-item" :class="{ active: activeTab === 'like' }" @click="switchTab('like')">
          <span class="tab-name nowrap">点赞消息</span>
          <el-badge v-if="likeMessageTotal > 0" is-dot class="tab-dot"></el-badge>
        </div>
        <div class="tab-item" :class="{ active: activeTab === 'send' }" @click="switchTab('send')">
          <span class="tab-name nowrap">发送礼物</span>
        </div>
      </div>
    </div>

    <!-- 在线状态筛选器 - 只在点赞消息时显示，放在第二行 -->
    <!-- <div class="online-filter" v-if="activeTab === 'like'">
      <div class="filter-label">在线状态:</div>
      <el-select v-model="selectedLikeType" @change="setLikeTypeFilter" placeholder="请选择" size="mini"
        class="filter-select">
        <el-option label="全部" :value="undefined"></el-option>
        <el-option label="在线" :value="0"></el-option>
        <el-option label="离线" :value="1"></el-option>
      </el-select>
    </div> -->

    <!-- 消息列表容器 -->
    <div class="left_content" ref="newMessageContainer">
      <!-- 初始加载状态 -->
      <div v-if="isLoading && newMessageList.length === 0" class="loading-container">
        <div class="loading-spinner"></div>
        <div class="loading-text">
          {{ activeTab === 'new' ? '正在加载新消息...' : activeTab === 'like' ? '正在加载点赞消息...' : '正在加载发送消息/礼物...' }}
        </div>
      </div>

      <!-- 消息列表 -->
      <template v-else-if="newMessageList.length > 0">
        <!-- 消息卡片列表 -->
        <ul v-infinite-scroll="loadMoreNewMessages" :infinite-scroll-disabled="isLoading || !hasMore"
          :infinite-scroll-distance="10" :infinite-scroll-immediate="false" class="infinite-list">
          <li v-for="(item, index) in newMessageList"
            :key="`newMessage-${item.requestId || item.id || Date.now()}-${index}`"
            class="infinite-list-item message-card-wrapper">
            <div @click="$emit('message-click', item)" style="cursor: pointer">
              <!-- 系统消息 -->
              <div class="sysMessageCard" v-if="item.type == 'sysMessage'">
                <div class="card_header">
                  <img class="profile" src="@/assets/systemImg.png" alt="" />
                  <div class="time">9分钟前</div>
                </div>
                <div class="info">
                  <div class="name">
                    <div class="name-text">
                      {{ item.userDetail ? '新消息' : '系统消息' }}
                    </div>
                  </div>
                  <div class="message">{{ item.message }}</div>
                </div>
              </div>

              <!-- 新消息、点赞消息和发送消息/礼物 -->
              <div class="messageCard" v-if="
                (item.type == 'newMessage' || item.type == 'likeMessage' || item.type == 'sendMessage') &&
                item.userDetail
              " :class="{
                'urgent-reminder':
                  item.type === 'newMessage' && isOver5Minutes(item),
              }">
                <div class="unread" v-if="item.unreadMessagesCount > 0">
                  {{ item.unreadMessagesCount }}
                </div>
                <div class="left">
                  <div class="photoBox">
                    <img v-if="item.userDetail" class="photo" :src="item.userDetail?.thumbnailUrl
                      ? item.userDetail?.thumbnailUrl
                      : require('@/assets/profile.png')
                      " alt="" />
                    <!-- 会员皇冠图标 -->
                    <img v-if="item.userDetail?.isVip == 1" class="crown-icon" src="@/assets/icon/vip.png" alt="VIP" />
                    <div class="status" v-if="item.is_online"></div>
                  </div>
                  <div class="time">{{ formatTime(item.dateCreatedStr) }}</div>
                </div>
                <div class="center">
                  <div class="center_top">
                    <div class="name">{{ item.userDetail.name }}</div>
                    <img v-if="item.isFavorite == 1" class="like" src="@/assets/heart.png" alt="" />
                    <!-- 超过5分钟未回复的红色提醒 - 只在新消息中显示 -->
                    <div v-if="item.type === 'newMessage' && isOver5Minutes(item)" class="urgent-badge-hover">
                      超过5分钟未回复
                    </div>
                  </div>
                  <messageFormat :data="item" :field="'messageType'" />
                </div>
                <div class="right">
                  <img class="right_photo" :src="item.platformUserDetail?.thumbnailUrl
                    ? item.platformUserDetail?.thumbnailUrl
                    : require('@/assets/profile.png')
                    " alt="" />
                  <!-- 会员皇冠图标 -->
                  <img v-if="item.platformUserDetail?.isVip == 1" class="crown-icon-right" src="@/assets/icon/vip.png"
                    alt="VIP" />
                  <div class="right_name">
                    {{ item.platformUserDetail.name }}
                  </div>
                </div>
              </div>

              <!-- 上线提醒 -->
              <div class="messageCard" v-if="item.type == 'online'">
                <div class="left">
                  <div style="display: flex">
                    <div class="leftHeader">
                      <img class="photo" :src="item.userDetail?.thumbnailUrl" alt="" />
                      <!-- 会员皇冠图标 -->
                      <img v-if="item.userDetail?.isVip == 1" class="crown-icon" src="@/assets/icon/vip.png"
                        alt="VIP" />
                      <div class="status" v-if="item.is_online"></div>
                    </div>
                    <div class="center_top">
                      <div class="name">{{ item.userDetail.name }}</div>
                      <img v-if="item.isFavorite == 1" class="like" src="@/assets/heart.png" alt="" />
                      <div class="btn">上线提醒</div>
                    </div>
                  </div>
                  <div class="time">{{ formatTime(item.timestamp) }}</div>
                </div>
                <div class="right">
                  <img class="right_photo" :src="item.platformUserDetail?.thumbnailUrl" alt="" />
                  <!-- 会员皇冠图标 -->
                  <img v-if="item.platformUserDetail?.isVip == 1" class="crown-icon-right" src="@/assets/icon/vip.png"
                    alt="VIP" />
                  <div class="right_name">
                    {{ item.platformUserDetail.name }}
                  </div>
                </div>
              </div>
            </div>
            <!-- 关闭按钮 -->
            <!-- <img class="close" src="@/assets/close.png" alt="" @click="closeMessage(item)"> -->
          </li>
        </ul>

        <!-- 加载更多状态 -->
        <div v-if="isLoading && hasMore" class="load-more-container">
          <div class="load-more-spinner"></div>
          <div class="load-more-text">正在加载更多...</div>
        </div>
      </template>

      <!-- 空状态 -->
      <div v-else-if="!isLoading" class="empty-state">
        <div class="empty-content">
          <div class="empty-icon">
            <img src="@/assets/heart.png" alt="" />
          </div>
          <div class="empty-title">
            {{ activeTab === 'new' ? '暂无新消息' : activeTab === 'like' ? '暂无点赞消息' : '暂无发送消息/礼物' }}
          </div>
          <div class="empty-subtitle">
            {{
              activeTab === 'new'
                ? '新的消息会在这里显示'
                : activeTab === 'like'
                  ? '点赞的消息会在这里显示'
                  : '发送的消息/礼物会在这里显示'
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { formatTime } from '@/utils/talkytimesFormat';
import messageFormat from '@/components/messageFormat.vue';
import {
  getPdNoReplyChatBoxesPage,
  delPdNoReplyChatBoxes,
  readNoticeMessage,
} from '@/api/dialogue';
import { getOnlineStatus } from '@/api/talkytimes/user';
import sseManager from '@/utils/sseManager';
import globalWebSocketManager from '@/utils/globalWebSocketManager';
import { getUserIsVip } from '@/api/talkytimes/message';

export default {
  name: 'NewMessagePanel',
  components: {
    messageFormat,
  },
  data() {
    return {
      // 消息列表数据
      newMessageList: [],
      // 当前激活的标签
      activeTab: 'new', // 'new' | 'like' | 'send'
      // 加载状态
      isLoading: false,
      // 是否还有更多数据
      hasMore: true,
      // 分页参数
      newMessageListParams: {
        limit: 15,
        offset: 0,
        type: 0, // 0-新消息，1-点赞消息，5-发送消息/礼物
        likeType: undefined, // 0-在线，1-离线，不传查全部
      },
      // 定时器
      timer: null,
      // 防抖定时器
      switchTabTimer: null,
      // 新消息刷新定时器
      refreshTimer: null,
      // 当前请求ID，用于取消请求
      currentRequestId: 0,
      // 选中的在线状态类型
      selectedLikeType: undefined, // 默认选择全部
      // 新消息总数
      newMessageTotal: 0,
      // 点赞消息总数
      likeMessageTotal: 0,
    };
  },
  computed: {
    // 计算属性可以在这里添加
  },
  watch: {
    // 移除了自动更新在线状态的监听，改为在请求数据后手动调用
  },
  methods: {
    formatTime,

    // 切换标签
    switchTab(tab) {
      console.log('切换标签', tab);
      if (this.activeTab === tab) return;

      // 清除之前的防抖定时器
      if (this.switchTabTimer) {
        clearTimeout(this.switchTabTimer);
      }

      // 防抖处理，避免快速切换
      this.switchTabTimer = setTimeout(() => {
        this.performTabSwitch(tab);
      }, 100);
    },

    // 执行实际的tab切换
    performTabSwitch(tab) {
      console.log('执行tab切换', tab);

      // 取消之前的请求
      this.cancelCurrentRequest();

      this.activeTab = tab;

      // 重置分页参数
      this.newMessageListParams.offset = 0;

      // 切换标签时清空列表，确保重新查询
      this.newMessageList = [];

      this.hasMore = true;

      // 根据切换的标签重新加载数据
      this.getNewMessageList(tab);

      // 启动或停止刷新定时器
      this.startOrStopRefreshTimer();
    },

    // 取消当前请求
    cancelCurrentRequest() {
      this.currentRequestId++;
      // 如果正在加载，标记为已取消
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

    // 切换新消息提示音
    toggleNewMessageSound() {
      this.$store.dispatch('sound/toggleNewMessageMuted');
    },

    // 切换点赞消息提示音
    toggleLikeMessageSound() {
      this.$store.dispatch('sound/toggleLikeMessageMuted');
    },

    // 设置在线状态筛选
    setLikeTypeFilter(likeType) {
      console.log('设置在线状态筛选:', likeType);

      // 清除之前的防抖定时器
      if (this.switchTabTimer) {
        clearTimeout(this.switchTabTimer);
      }

      // 防抖处理，避免快速切换状态
      this.switchTabTimer = setTimeout(() => {
        this.performLikeTypeFilter(likeType);
      }, 150);
    },

    // 执行实际的状态筛选
    performLikeTypeFilter(likeType) {
      console.log('执行状态筛选:', likeType);

      // 取消之前的请求
      this.cancelCurrentRequest();

      this.selectedLikeType = likeType;
      this.newMessageListParams.likeType = likeType;

      // 重置分页参数
      this.newMessageListParams.offset = 0;
      this.newMessageList = [];
      this.hasMore = true;

      // 根据当前激活的标签重新加载数据
      const currentTab = this.activeTab;
      this.getNewMessageList(currentTab);
    },

    // 检查是否超过5分钟
    isOver5Minutes(item) {
      // 过滤点赞消息
      if (this.activeTab == 'like') {
        return false;
      }

      // 过滤阅读邮件提醒和giftLimit消息
      if (
        item.messageType === 'platform_CorrespondenceLimitChanged' ||
        item.messageType === 'reaMail' ||
        item.messageType === 'readMail' ||
        item.messageType === 'giftLimit' ||
        item.messageType === 'sendNewMessage'
      ) {
        return false;
      }

      // 调试信息：打印消息类型
      console.log(
        '检查消息类型:',
        item.type,
        '消息ID:',
        item.requestId || item.id
      );

      if (!item || !item.dateCreatedStr) {
        console.log('跳过检查 - 缺少必要数据');
        return false;
      }
      const messageDate = dayjs(item.dateCreatedStr);
      const now = dayjs();
      const diffMinutes = now.diff(messageDate, 'minute');
      const isOver = diffMinutes > 5;
      console.log('时间差:', diffMinutes, '分钟, 是否超过5分钟:', isOver);
      return isOver;
    },

    // 获取新消息列表
    async getNewMessageList(v) {
      if (this.isLoading) return Promise.resolve();

      const requestId = ++this.currentRequestId;
      let MessageType = 0;
      if (this.activeTab === 'new') {
        MessageType = 0;
      } else if (this.activeTab === 'like') {
        MessageType = 1;
      } else if (this.activeTab === 'send') {
        MessageType = 5;
      }
      this.newMessageListParams.type = MessageType;

      // 如果是切换标签，重置分页参数
      if (v === 'new' || v === 'like' || v === 'send') {
        this.newMessageListParams.offset = 0;
        // 切换标签时清空列表，确保重新查询
        this.newMessageList = [];
      }

      this.isLoading = true;

      try {
        let res = await getPdNoReplyChatBoxesPage(this.newMessageListParams);
        console.log('getNewMessageList:::::', res);

        if (res && res.code == 200) {
          // 检查请求是否已被取消（tab已切换）
          if (requestId !== this.currentRequestId) {
            console.log('请求已被取消，忽略响应');
            return Promise.resolve();
          }

          // 如果是新消息类型且type为0，更新新消息总数和未读消息数量
          if (MessageType === 0) {
            // 使用接口返回的total字段更新新消息总数
            if (res.total !== undefined) {
              this.newMessageTotal = res.total;
              console.log('更新新消息总数:', this.newMessageTotal);

              // 同时更新store中的未读数量，使用total字段而不是data.length
              this.$store.dispatch(
                'accountList/updateUnreadCountByNewMessages',
                Array(res.total).fill({})
              );
              console.log('已更新store中的未读数量为total值:', res.total);
            }

            // 根据实际的新消息数据更新未读数量（保持原有逻辑作为备用）
            if (res.data && res.data.length > 0) {
              // 注释掉原有的逻辑，因为我们已经用total更新了
              // this.$store.dispatch(
              //   'accountList/updateUnreadCountByNewMessages',
              //   res.data
              // );
            }
          } else if (MessageType === 1) {
            if (res.total !== undefined) {
              this.likeMessageTotal = res.total;
            }
          }
          // 更新发送消息者的会员状态
          const fromIds = res.data.map((item) => item.idUserFrom);
          // const isVipRes = await getUserIsVip(fromIds);
          // console.log('isVipRes:::::', isVipRes);
          let newMessage = res.data.map((item) => {
            // console.log('item:::::::wozaizhe::::', item);

            // 如果是邮件类型，时间+8小时
            let adjustedDateCreatedStr = item.dateCreatedStr;
            if (adjustedDateCreatedStr) {
              if (item.messageType === 'mail') {
                const originalDate = dayjs(item.dateCreatedStr);
                const adjustedDate = originalDate.add(8, 'hour');
                adjustedDateCreatedStr = adjustedDate.format(
                  'YYYY-MM-DD HH:mm:ss'
                );
              }
            }
            return {
              ...item,
              // isVip: isVipRes[item.idUserFrom]?.isVip || false,
              // isUnmanagedVip:
              //   isVipRes[item.idUserFrom]?.isUnmanagedVip || false,
              isVip: false,
              isUnmanagedVip: false,
              message: item.content,
              mailId:
                item.messageType == 'mail' ? Number(item.messageId) : undefined,
              type: this.getDynamicMessageType(item), // 动态设置类型
              idInterlocutor: Number(item.idUserFrom),
              userId: Number(item.idUserFrom),
              idUser: Number(item.idUserTo),
              platformUserId: Number(item.idUserTo),
              is_online: false,
              dateCreatedStr: adjustedDateCreatedStr, // 使用调整后的时间
              platformUserDetail: {
                id: Number(item.idUserTo),
                thumbnailUrl: item.idUserAvatar,
                avatar_large: item.idUserAvatar,
                avatar_small: item.idUserAvatar,
                name: item.idUserName,
              },
              userDetail: {
                id: Number(item.idUserFrom),
                thumbnailUrl: item.idUserFromAvatar,
                avatar_small: item.idUserFromAvatar,
                avatar_large: item.idUserFromAvatar,
                name: item.idUserFromName,
                // isVip: isVipRes[item.idUserFrom]?.isVip || false,
                // isUnmanagedVip:
                //   isVipRes[item.idUserFrom]?.isUnmanagedVip || false,
                isVip: false,
                isUnmanagedVip: false,
                is_online: false, // 初始化在线状态，后续通过API更新
              },
            };
          });

          // 再次检查请求是否已被取消
          if (requestId !== this.currentRequestId) {
            console.log('数据处理完成前请求已被取消，忽略结果');
            return Promise.resolve();
          }

          // 检测并补充缺失的用户头像和昵称信息
          await this.supplementMissingUserInfo(newMessage);

          // 根据标签类型处理数据
          if (v === 'new' || v === 'like' || v === 'send') {
            // 切换到新标签时，直接替换列表
            this.newMessageList = newMessage;
          } else {
            // 加载更多时，追加到列表
            this.newMessageList = [...this.newMessageList, ...newMessage];
          }

          // 更新分页参数
          this.newMessageListParams = {
            limit: this.newMessageListParams.limit,
            offset:
              this.newMessageListParams.offset +
              this.newMessageListParams.limit,
          };

          // 判断是否还有更多数据
          this.hasMore = newMessage.length >= this.newMessageListParams.limit;

          // 检查是否需要加载更多数据
          this.$nextTick(() => {
            this.checkIfNeedMoreNewMessageData();
          });

          // 请求数据成功后，更新在线状态
          if (this.newMessageList.length > 0) {
            this.updateOnlineStatus();
          }

          return Promise.resolve(res);
        }
      } catch (error) {
        // 检查请求是否已被取消
        if (requestId !== this.currentRequestId) {
          console.log('请求错误但已被取消，忽略错误');
          return Promise.resolve();
        }
        console.error('获取新消息列表失败:', error);
        return Promise.reject(error);
      } finally {
        // 只有当前请求才设置loading状态
        if (requestId === this.currentRequestId) {
          this.isLoading = false;
        }
      }
    },

    // 动态设置消息类型
    getDynamicMessageType(item) {
      // 根据消息类型和当前tab动态设置type
      if (item.messageType === 'platform_CorrespondenceLimitChanged') {
        return 'sysMessage';
      }

      if (this.activeTab === 'like') {
        return 'likeMessage';
      }

      if (this.activeTab === 'send') {
        return 'sendMessage';
      }

      // // 根据实际消息类型判断
      // if (item.messageType === 'mail') {
      //   return 'mailMessage';
      // }

      if (
        item.messageType.indexOf('like') !== -1 ||
        item.messageType.indexOf('wink') !== -1
      ) {
        return 'likeMessage';
      }

      return 'newMessage'; // 默认类型
    },

    // 检测并补充缺失的用户头像和昵称信息
    async supplementMissingUserInfo(messageList) {
      if (!messageList || messageList.length === 0) return;

      // 收集需要补充信息的用户ID
      const needSupplementUserIds = [];
      const needSupplementPlatformUserIds = [];

      messageList.forEach((item) => {
        // 检查用户信息是否缺失头像或昵称
        if (item.userDetail) {
          const hasMissingUserInfo =
            !item.userDetail.thumbnailUrl ||
            !item.userDetail.avatar_small ||
            !item.userDetail.avatar_large ||
            !item.userDetail.name;
          if (hasMissingUserInfo && item.userDetail.id) {
            needSupplementUserIds.push(item.userDetail.id);
          }
        }
        // 检查平台用户信息是否缺失头像或昵称
        if (item.platformUserDetail) {
          const hasMissingPlatformUserInfo =
            !item.platformUserDetail.thumbnailUrl ||
            !item.platformUserDetail.avatar_small ||
            !item.platformUserDetail.avatar_large ||
            !item.platformUserDetail.name;
          if (hasMissingPlatformUserInfo && item.platformUserDetail.id) {
            needSupplementPlatformUserIds.push(item.platformUserDetail.id);
          }
        }
      });

      // 合并所有需要查询的用户ID，去重
      const allUserIds = [
        ...new Set([
          ...needSupplementUserIds,
          ...needSupplementPlatformUserIds,
        ]),
      ];

      if (allUserIds.length === 0) return;

      try {
        console.log('检测到缺失用户信息，正在补充:', allUserIds);

        // 调用getConnectionsProfiles接口获取用户资料
        const { getConnectionsProfiles } = await import(
          '@/api/talkytimes/personalData'
        );
        const res = await getConnectionsProfiles({ ids: allUserIds });

        if (
          res &&
          res.data &&
          res.data.profiles &&
          res.data.profiles.length > 0
        ) {
          // 创建用户资料映射表
          const userProfilesMap = {};
          res.data.profiles.forEach((profile) => {
            userProfilesMap[profile.id] = profile;
          });

          // 补充缺失的用户信息
          messageList.forEach((item) => {
            // 补充用户信息
            if (
              item.userDetail &&
              item.userDetail.id &&
              userProfilesMap[item.userDetail.id]
            ) {
              const profile = userProfilesMap[item.userDetail.id];
              if (!item.userDetail.thumbnailUrl) {
                item.userDetail.thumbnailUrl =
                  profile.thumbnailUrl || profile.personal.avatar_small;
              }
              if (!item.userDetail.avatar_small) {
                item.userDetail.avatar_small =
                  profile.avatar_small || profile.personal.avatar_small;
              }
              if (!item.userDetail.avatar_large) {
                item.userDetail.avatar_large =
                  profile.avatar_large || profile.personal.avatar_large;
              }
              if (!item.userDetail.name) {
                item.userDetail.name = profile.name;
              }
            }

            // 补充平台用户信息
            if (
              item.platformUserDetail &&
              item.platformUserDetail.id &&
              userProfilesMap[item.platformUserDetail.id]
            ) {
              const profile = userProfilesMap[item.platformUserDetail.id];
              if (!item.platformUserDetail.thumbnailUrl) {
                item.platformUserDetail.thumbnailUrl =
                  profile.thumbnailUrl || profile.personal.avatar_small;
              }
              if (!item.platformUserDetail.avatar_small) {
                item.platformUserDetail.avatar_small =
                  profile.avatar_small || profile.personal.avatar_small;
              }
              if (!item.platformUserDetail.avatar_large) {
                item.platformUserDetail.avatar_large =
                  profile.avatar_large || profile.personal.avatar_large;
              }
              if (!item.platformUserDetail.name) {
                item.platformUserDetail.name = profile.name;
              }
            }
          });

          console.log('用户信息补充完成');
        }
      } catch (error) {
        console.error('补充用户信息失败:', error);
      }
    },

    // 加载更多新消息
    loadMoreNewMessages() {
      if (this.isLoading || !this.hasMore) return;
      console.log('加载更多新消息');
      this.getNewMessageList('more');
    },

    // 检查新消息是否需要加载更多数据
    checkIfNeedMoreNewMessageData() {
      const container = this.$refs.newMessageContainer;
      if (!container) return;

      const hasScrollbar = container.scrollHeight > container.clientHeight;
      // 如果没有滚动条且还有更多数据，继续加载
      if (!hasScrollbar && this.hasMore && !this.isLoading) {
        // 数据不足以产生滚动条，继续加载
        this.loadMoreNewMessages();
      }
    },

    // 更新在线状态
    updateOnlineStatus() {
      let ids = this.newMessageList.map((item) => item.idUserFrom);
      if (ids.length === 0) return;

      getOnlineStatus({ ids }).then((res) => {
        this.newMessageList.forEach((item) => {
          let is_online = res[item.idUserFrom] ? res[item.idUserFrom] : false;
          this.$set(item, 'is_online', is_online);
          // 同步到嵌套的 userDetail，保证进入聊天页后状态一致
          if (item.userDetail) {
            this.$set(item.userDetail, 'is_online', is_online);
          }
        });
      }).catch((error) => {
        // 如果是 PD服务器请求失败: ConnectException: Connection timed out 错误，静默处理，不显示错误提示
        if (error && error.msg && error.msg.includes('PD服务器请求失败') && error.msg.includes('Connection timed out')) {
          console.log('在线状态查询失败（连接超时），静默处理');
          return;
        }
        // 其他错误也静默处理，在线状态查询失败不应该影响用户体验
        console.log('在线状态查询失败，静默处理:', error);
      });
    },

    // 关闭pd消息
    closeMessage(item) {
      console.log('消息类型', item);
      delPdNoReplyChatBoxes(item.id).then((res) => {
        console.log('删除未回复聊天', res);
        this.newMessageList = this.newMessageList.filter(
          (ite) => ite.id != item.id
        );
        if (this.activeTab === 'like') {
          this.fetchLikeMessageTotal();
        }
        // 通知父组件未读数量已更新
        this.$emit('unreadCountChanged', this.newMessageList.length);
      });
    },
    // 关闭本系统消息
    closeNoticeMessage(item) {
      console.log('消息类型', item);
      return;
      readNoticeMessage(item.id).then((res) => {
        console.log('删除阅读邮件', res);
        this.newMessageList = this.newMessageList.filter(
          (ite) => ite.id != item.id
        );
        // 通知父组件未读数量已更新
        this.$emit('unreadCountChanged', this.newMessageList.length);
      });
    },
    // 处理新消息（从SSE或其他地方接收）
    handleNewMessage(data) {
      console.log('handleNewMessage:::::', data);
      const isLikeMessage =
        data.messageType.indexOf('like') !== -1 ||
        data.messageType.indexOf('wink') !== -1;
      if (isLikeMessage) {
        this.fetchLikeMessageTotal();
        if (this.activeTab === 'like') {
          this.getNewMessageList('new');
        }
        return;
      }
      if (this.activeTab === 'new') {
        this.getNewMessageList('new');
      }
    },

    // 获取点赞消息总数（用于标签红点提醒）
    async fetchLikeMessageTotal() {
      const res = await getPdNoReplyChatBoxesPage({
        limit: 1,
        offset: 0,
        type: 1,
        likeType: this.selectedLikeType,
      });
      if (res && res.code == 200 && res.total !== undefined) {
        this.likeMessageTotal = res.total;
      }
    },

    // 添加新消息
    addNewMessage(data, type, isLike) {
      console.log('添加新消息', data, type);

      // 转换消息数据格式，使其与组件期望的格式一致
      const newMessage = {
        ...data,
        message: data.content?.message || data.content || '',
        mailId:
          data.messageType === 'mail' ? Number(data.messageId) : undefined,
        type: this.getDynamicMessageType(data), // 动态设置类型
        idInterlocutor: Number(data.idUserFrom),
        userId: Number(data.idUserFrom),
        idUser: Number(data.idUserTo),
        platformUserId: Number(data.idUserTo),
        is_online: false,
        dateCreatedStr: data.dateCreatedStr,
        unreadMessagesCount: data.unreadMessagesCount || 1, // 新消息默认未读数量为1
        platformUserDetail: {
          id: Number(data.idUserTo),
          thumbnailUrl: data.idUserAvatar,
          avatar_large: data.idUserAvatar,
          avatar_small: data.idUserAvatar,
          name: data.idUserName,
        },
        userDetail: {
          id: Number(data.idUserFrom),
          thumbnailUrl: data.idUserFromAvatar,
          avatar_small: data.idUserFromAvatar,
          avatar_large: data.idUserFromAvatar,
          name: data.idUserFromName,
          isVip: data.isVip || false,
          isUnmanagedVip: data.isUnmanagedVip || false,
          is_online: false, // 初始化在线状态，后续通过API更新
        },
      };

      if (type === 'new' && !isLike) {
        // 新消息类型，添加到新消息列表
        // 检查是否已存在相同用户的消息
        const existingIndex = this.newMessageList.findIndex(
          (item) =>
            item.idUserFrom === data.idUserFrom && item.type === 'newMessage'
        );

        if (existingIndex !== -1) {
          // 如果已存在，更新现有消息
          this.$set(this.newMessageList, existingIndex, {
            ...this.newMessageList[existingIndex],
            ...newMessage,
            unreadMessagesCount:
              (this.newMessageList[existingIndex].unreadMessagesCount || 0) + 1,
            dateCreatedStr: data.dateCreatedStr, // 更新时间
          });
        } else {
          // 如果不存在，添加到列表开头
          this.newMessageList.unshift(newMessage);
        }
      } else if (type === 'like' && isLike) {
        // 点赞消息类型，添加到点赞消息列表
        // 检查是否已存在相同用户的消息
        const existingIndex = this.newMessageList.findIndex(
          (item) =>
            item.idUserFrom === data.idUserFrom && item.type === 'likeMessage'
        );

        if (existingIndex !== -1) {
          // 如果已存在，更新现有消息
          this.$set(this.newMessageList, existingIndex, {
            ...this.newMessageList[existingIndex],
            ...newMessage,
            dateCreatedStr: data.dateCreatedStr, // 更新时间
          });
        } else {
          // 如果不存在，添加到列表开头
          this.newMessageList.unshift(newMessage);
        }
      }
    },

    // 根据消息类型播放提示音
    playMessageSound(isLikeMessage) {
      // 点赞消息和发送消息/礼物默认不播放声音
      if (isLikeMessage || this.activeTab === 'send') {
        return;
      }
      // 如果是新消息且新消息提示音未静音，则播放提示音
      if (!isLikeMessage && !this.$store.state.sound.newMessageMuted) {
        const audio = document.getElementById('audioAuto');
        if (audio) {
          audio.play();
        }
      }
    },

    // 初始化组件
    init() {
      this.getNewMessageList('new');
      this.fetchLikeMessageTotal();
    },

    // 刷新数据
    refresh() {
      this.getNewMessageList('new');
    },

    // 根据用户ID移除消息
    removeMessageByUserId(userId, platformUserId, currentMessageType = 'chat') {
      const index = this.newMessageList.findIndex((item) => {
        if (item.idUserFrom != userId || item.idUserTo != platformUserId) {
          return false;
        }
        // 根据当前消息类型查找对应的消息
        if (currentMessageType == 'chat') {
          return item.messageType != 'mail';
        } else if (currentMessageType == 'email') {
          return item.messageType == 'mail';
        }

      });

      if (index !== -1) {
        const removedMessage = this.newMessageList[index];
        if (
          removedMessage.messageType === 'readMail' ||
          removedMessage.messageType === 'reaMail'
        ) {
          readNoticeMessage(removedMessage.id);
          this.newMessageList.splice(index, 1);
          this.$emit('unreadCountChanged', this.newMessageList.length);
        } else {
          // 其他类型的消息使用原来的逻辑
          this.newMessageList.splice(index, 1);
          delPdNoReplyChatBoxes(platformUserId);
        }
        if (this.activeTab === 'like') {
          this.fetchLikeMessageTotal();
        }
        this.$emit('unreadCountChanged', this.newMessageList.length);
      }
    },

    // 更新未读消息数量
    updateUnreadCount(userId, count) {
      const index = this.newMessageList.findIndex(
        (item) => item.idUserFrom == userId
      );
      if (index !== -1) {
        this.$set(this.newMessageList[index], 'unreadMessagesCount', count);
        // 注释掉自动移除消息的逻辑，点击不再移除消息
        // if (count === 0) {
        //   this.newMessageList.splice(index, 1);
        // }
        // 触发未读数量变化事件
        this.$emit('unreadCountChanged', this.newMessageList.length);
      }
    },

    // 更新心情
    updateMood(mood) {
      this.newMessageList.forEach((item) => {
        if (item.platformUserDetail) {
          this.$set(item.platformUserDetail, 'mood', mood);
        }
      });
    },

    // 启动或停止新消息刷新定时器
    startOrStopRefreshTimer() {
      // 清除现有定时器
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }

      // 如果当前标签是新消息，启动定时器
      if (this.activeTab === 'new') {
        this.refreshTimer = setInterval(() => {
          // 只在当前标签是新消息时刷新
          if (this.activeTab === 'new') {
            this.getNewMessageList('new');
          }
        }, 60000); // 每60秒刷新一次
      }
    },
  },
  mounted() {
    // 启动定时器，每分钟检查一次消息时间
    this.timer = setInterval(() => {
      // 强制更新计算属性
      this.$forceUpdate();
    }, 60000); // 每分钟检查一次

    // 初始化数据
    this.init();

    // 启动新消息刷新定时器（如果当前标签是新消息）
    this.startOrStopRefreshTimer();

    // 注册SSE消息处理器
    sseManager.registerMessageHandler('newMessageCard', (data, event) => {
      console.log('newMessageCard:::::', data);
      this.handleNewMessage(data.data || data);
    });

    // 注册WebSocket消息处理器
    globalWebSocketManager.registerMessageHandler('newMessageCard', (data) => {
      console.log('newMessageCard WebSocket:::::', data);
      this.handleNewMessage(data);
    });
  },
  beforeDestroy() {
    // 清理定时器
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    // 清理新消息刷新定时器
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }

    // 清理tab切换防抖定时器
    if (this.switchTabTimer) {
      clearTimeout(this.switchTabTimer);
      this.switchTabTimer = null;
    }

    // 取消当前请求
    this.cancelCurrentRequest();

    // 注销SSE消息处理器
    sseManager.unregisterMessageHandler('newMessageCard');

    // 注销WebSocket消息处理器
    globalWebSocketManager.unregisterMessageHandler('newMessageCard');
  },
};
</script>

<style lang="scss" scoped>
.new-message-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.left_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;

  .message-tabs {
    display: flex;
    align-items: center;

    .tab-item {
      cursor: pointer;
      padding: 12px 16px;
      transition: all 0.3s ease;
      position: relative;
      display: flex;
      align-items: center;
      gap: 8px;
      background: transparent;

      .tab-name {
        font-weight: 500;
        font-size: 14px;
        color: #606266;
        transition: color 0.3s ease;
      }

      .tab-sound-icon {
        opacity: 0.6;
        transition: opacity 0.3s ease;

        &:hover {
          opacity: 1;
        }
      }

      &.active {
        background: transparent;

        .tab-name {
          color: #1890ff;
          font-weight: 500;
        }

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 2px;
          background-color: #1890ff;
        }
      }

      &:hover:not(.active) {
        background: transparent;

        .tab-name {
          color: #1890ff;
        }
      }
    }
  }
}

.left_content {
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;

  // 隐藏x轴滚动条
  &::-webkit-scrollbar-x {
    display: none;
  }

  .infinite-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .infinite-list-item {
    position: relative;
    margin-bottom: 12px;
  }

  .loadingImg {
    width: 30px;
    height: 30px;
    margin: 0 auto;
  }
}

/* 初始加载状态样式 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 200px;
  padding: 40px 20px;

  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #1890ff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
  }

  .loading-text {
    font-size: 14px;
    color: #666;
    text-align: center;
  }
}

/* 加载更多状态样式 */
.load-more-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin: 12px 18px 0 0;

  .load-more-spinner {
    width: 24px;
    height: 24px;
    border: 2px solid #e0e0e0;
    border-top: 2px solid #1890ff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 8px;
  }

  .load-more-text {
    font-size: 12px;
    color: #999;
    text-align: center;
  }
}

/* 旋转动画 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

// 空状态样式
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 200px;

  .empty-content {
    text-align: center;
    color: #909399;

    .empty-icon {
      display: flex;
      justify-content: center;
      margin-bottom: 16px;

      img {
        width: 56px;
        height: 56px;
        opacity: 0.8;
        filter: grayscale(20%) brightness(105%);
      }
    }

    .empty-title {
      font-size: 16px;
      font-weight: 500;
      color: #606266;
      margin-bottom: 8px;
    }

    .empty-subtitle {
      font-size: 12px;
      color: #909399;
      line-height: 1.4;
    }
  }
}

.like {
  width: 14px;
  height: 14px;
  margin-right: 6px;
}

.close {
  width: 10px;
  height: 10px;
  position: absolute;
  top: 2px;
  right: 1px;
  cursor: pointer;
}

.sysMessageCard {
  min-width: 248px;
  box-sizing: border-box;
  padding: 8px;
  background-color: #f7f9fa;
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  margin-right: 18px;

  .card_header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .profile {
      width: 50px;
      height: 50px;
      cursor: pointer;
      margin-bottom: 6px;
    }

    .time {
      width: 80px;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
    }
  }

  .info {
    width: 80%;
    display: flex;
    flex-direction: column;

    .name {
      display: flex;
      align-items: center;
      margin-bottom: 6px;

      .name-text {
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        margin-right: 6px;
      }
    }
  }

  .message {
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 1;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
}

.messageCard {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
  background-color: #f7f9fa;
  border-radius: 8px;
  margin-bottom: 4px;
  cursor: pointer;

  .left {
    padding-right: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .photoBox {
      width: 36px;
      height: 36px;
      margin-bottom: 6px;
      position: relative;

      .photo {
        width: 36px;
        height: 36px;
        border-radius: 8px;
      }

      .crown-icon {
        position: absolute;
        top: -4px;
        right: -4px;
        width: 16px;
        height: 16px;
        z-index: 10;
      }

      .status {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #0cd85d;
      }
    }

    .time {
      font-weight: 400;
      font-size: 10px;
      line-height: 1;
      color: #999999;
      white-space: nowrap;
    }
  }

  .center {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-self: flex-start;
    margin-right: 13px;
    min-width: 60px;

    .center_top {
      display: flex;
      align-items: center;
      margin-bottom: 6px;

      .name {
        font-weight: bold;
        font-size: 12px;
        line-height: 1;
        color: #333333;
        margin-right: 6px;
        white-space: nowrap;
      }

      .status {
        width: 14px;
        height: 14px;
      }
    }
  }

  .right {
    min-width: 130px;
    height: 44px;
    display: flex;
    box-sizing: border-box;
    align-items: center;
    padding: 4px;
    background-color: #fff;
    border-radius: 8px;

    .right_photo {
      width: 36px;
      height: 36px;
      margin-right: 8px;
      border-radius: 8px;
    }

    .crown-icon-right {
      position: absolute;
      top: -4px;
      right: -4px;
      width: 16px;
      height: 16px;
      z-index: 10;
    }

    .right_name {
      flex: 1;
      font-weight: 500;
      font-size: 11px;
      color: #333333;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 90px;
    }
  }
}

.unread {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: red;
  position: absolute;
  color: #fff;
  font-size: 10px;
  line-height: 16px;
  text-align: center;
  left: 0;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 在线状态筛选器样式 */
.online-filter {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #f8f9fa;
  border-bottom: 1px solid #eee;

  .filter-label {
    font-size: 12px;
    color: #666;
    margin-right: 8px;
    white-space: nowrap;
  }

  .filter-select {
    width: 80px;

    :deep(.el-input__inner) {
      height: 24px;
      line-height: 24px;
      font-size: 11px;
      padding: 0 8px;
    }

    :deep(.el-input__suffix) {
      height: 24px;
    }

    :deep(.el-input__suffix-inner) {
      height: 24px;
      line-height: 24px;
    }
  }
}

/* 标签badge样式 */
.tab-badge {
  margin-left: 8px;

  :deep(.el-badge__content) {
    background-color: #f56c6c;
    border-color: #f56c6c;
    font-size: 10px;
    height: 16px;
    line-height: 16px;
    min-width: 16px;
    padding: 0 4px;
  }
}

/* 点赞标签红点样式 */
.tab-dot {
  margin-left: 4px;

  :deep(.el-badge__content.is-dot) {
    background-color: #f56c6c;
    border-color: #f56c6c;
    width: 8px;
    height: 8px;
  }
}

.urgent-reminder {
  border: 2px solid #ff4444 !important;
  background-color: #fff5f5 !important;
  box-shadow: 0 0 8px rgba(255, 68, 68, 0.3);
}

.urgent-badge-hover {
  background-color: #ff4444;
  color: white;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: bold;
  margin-left: 8px;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 10;
  position: absolute;
  right: 0px;
  top: 0;
}

.messageCard:hover .urgent-badge-hover {
  opacity: 1;
}
</style>
